module.exports = require("delay");


//////////////////
// WEBPACK FOOTER
// external "delay"
// module id = 43
// module chunks = 0